import { DeliveryStatus } from 'generated/rbi-graphql';
import { isDelivery } from 'utils/service-mode';

import { IOnOrderStatusChangeOptions } from './types';

type OrderAndStatuses = 'orderStatus' | 'orderDeliveryStatus' | 'serverOrder';
type OrderStatusesAndPrevious = OrderAndStatuses | 'prevOrderStatus' | 'prevOrderDeliveryStatus';

export const statusHasChanged = ({
  orderStatus,
  orderDeliveryStatus,
  prevOrderDeliveryStatus,
  prevOrderStatus,
  serverOrder,
}: Pick<IOnOrderStatusChangeOptions, OrderStatusesAndPrevious>) => {
  const isDeliveryOrder = isDelivery(serverOrder && serverOrder.cart.serviceMode);
  // status is not considered "changed" if there was no previous status,
  // since there is no "previous" status to compare with
  // this prevents duplicate events from firing if the user hard refreshes the page
  // BUT we add a new condition, if the preOrderDeliveryStatus is null, and is a deliveryOrder
  // and the final status is QUOTE_SUCCESSFUL we return true in the deliveryStatusHasChanged
  const posStatusHasChanged = !!prevOrderStatus && orderStatus !== prevOrderStatus;
  const deliveryStatusHasChanged =
    !!prevOrderDeliveryStatus &&
    (orderDeliveryStatus !== prevOrderDeliveryStatus ||
      DeliveryStatus.QUOTE_SUCCESSFUL === orderDeliveryStatus);

  return isDeliveryOrder ? posStatusHasChanged || deliveryStatusHasChanged : posStatusHasChanged;
};

export const handleOrderStatusChange = ({
  failure,
  logOrderLatency,
  logger,
  onSuccess,
  orderStatus,
  orderDeliveryStatus,
  prevOrderStatus,
  prevOrderDeliveryStatus,
  serverOrder,
  success,
}: IOnOrderStatusChangeOptions) => {
  if (!serverOrder) {
    return;
  }

  const orderStatusHasChanged = statusHasChanged({
    orderStatus,
    orderDeliveryStatus,
    prevOrderStatus,
    prevOrderDeliveryStatus,
    serverOrder,
  });

  if ((!success && !failure) || !orderStatusHasChanged) {
    return;
  }

  try {
    logOrderLatency(serverOrder);
  } catch (error) {
    logger.error({ error, message: 'Error logging order latency metric' });
  }

  if (success) {
    onSuccess(serverOrder);
  }
};
